module.exports = __webpack_public_path__ + "img/announcement-icon.dd90d6bd.webp";